import { useMemo } from 'react';
import { InputProps } from '@cad-arc';
import { useApplicationType } from './use-application-type';

export function useInputSizeForApplicationType(sizeFromProps?: InputProps['size'], options?: { frSizeOverride?: InputProps['size'] }) {
    const { isFirstResponder } = useApplicationType();

    return useMemo(() => {
        if (sizeFromProps) {
            return sizeFromProps;
        } else if (isFirstResponder) {
            return options?.frSizeOverride ?? 'xl';
        } else {
            //use the default
            return undefined;
        }
    }, [isFirstResponder, sizeFromProps, options?.frSizeOverride]);
}
